
import styles from '../ProductInfo.module.css';

interface MessageInputProps {
    message: string;
    setMessage: (val: string) => void;
}

export const MessageInput = ({ message, setMessage }: MessageInputProps) => {
    return (
        <>
            <h4 className={styles.customizationTitle}>Votre message</h4>
            <div style={{ width: '100%' }}>
                <textarea
                    className={styles.initialInput}
                    style={{
                        width: '100%',
                        height: '100px',
                        textAlign: 'left',
                        padding: '15px',
                        textTransform: 'none',
                        borderRadius: '15px',
                        fontSize: '1rem',
                        resize: 'none',
                        fontFamily: 'inherit',
                        border: '2px solid #0B2330' // Dark blue border from image
                    }}
                    placeholder="Je t'aime aujourd'hui et pour toujours."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
            </div>
        </>
    );
};
